import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import { Locale } from 'vant';
// 引入英文语言包
import koKO from 'vant/es/locale/lang/ko-KO';
Locale.use('ko-KO', koKO);
// import jaJP from 'vant/es/locale/lang/ja-JP';
// Locale.use('ja-JP', jaJP);
import 'video.js/dist/video-js.css'
import i18n from './i18n';
import Hls from 'hls';

import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import '@vant/touch-emulator';
window.Hls = Hls;
Vue.use(VueDPlayer);


Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
